import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class LiquidationDispatch extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Liquidation Dispatch Jobs
					</div>
					<div>
						<DownloadFile title="Liquidation Dispatch Jobs Header" url="ingest/liquidation/imrs/trigger/template"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/liquidation/imrs/trigger"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/Components/LiquidationDispatch.js